import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetQrcodeUrlToGenerate(id) {
  return maintainRequest.get(
    `/device/maintenanceMan/deviceQRCode/getQrcodeUrlToGenerate?deviceId=${id}`
  );
}
